import { GetCompanySettingsResponseSchema } from '@shared/schema/company.settings.get.schema'
import { queryOptions } from '@tanstack/react-query'

import { type QueryOptionsData } from '@/@types/query'
import { apiFetch } from '@/lib/api-fetch'

export function companySettingsQuery() {
  return queryOptions({
    queryKey: ['company', 'settings'],
    async queryFn() {
      const rawResponse = await apiFetch.get('company/settings')

      if (!rawResponse.ok) {
        throw new Error(`Failed to fetch company settings`)
      }

      try {
        return await GetCompanySettingsResponseSchema.parseAsync(await rawResponse.json())
      } catch (error) {
        throw new Error('Failed to parse company settings response', { cause: error })
      }
    },
  })
}

export type CompanySettings = QueryOptionsData<typeof companySettingsQuery>
